import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class Segment extends PureComponent {
  constructor(props) {
    super(props);

    this.focus = this.focus.bind(this);
  }

  focus() {
    this.button.focus();
  }

  render() {
    const { disabled, text, active, value, onChange, id } = this.props;

    return (
      <button
        type="button"
        className={`pxl-segmented__segment ${active ? 'pxl-segmented--active' : ''}`}
        onClick={onChange.bind(null, id, value)}
        disabled={disabled}
        ref={button => {
          this.button = button;
        }}
      >
        {text}
      </button>
    );
  }
}

Segment.propTypes = {
  active: PropTypes.bool,
  id: PropTypes.string,
  onChange: PropTypes.func,
  text: PropTypes.string,
  value: PropTypes.any,
  disabled: PropTypes.bool
};

export default Segment;
